import { render, staticRenderFns } from "./receiveDocument.vue?vue&type=template&id=01826c80&scoped=true"
import script from "./receiveDocument.vue?vue&type=script&lang=js"
export * from "./receiveDocument.vue?vue&type=script&lang=js"
import style0 from "./receiveDocument.vue?vue&type=style&index=0&id=01826c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01826c80",
  null
  
)

export default component.exports